/**
 * Copyright 2021 mmmint.ai info@mmmint.ai - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential to MMM Intelligence UG (haftungsbeschränkt).
 */
import accountService from "@/services/thg/services/accountService";
import {
  ThgAccountControllerCreateAccountParamsGen,
  ThgAccountDtoGen,
  ThgAccountViewmodelGen,
  ThgOperationIdViewModelGen,
  ThgUpdateAccountDtoGen
} from "@/services/thg/v1/data-contracts";
import store from "@/store/VuexPlugin";
import { Action, getModule, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({
  dynamic: true,
  namespaced: true,
  name: "account",
  store
})
export class AccountStore extends VuexModule {
  private _allAccounts: any[] = [];

  get allAccounts(): ThgAccountViewmodelGen[] {
    return this._allAccounts;
  }

  @Mutation
  mutateAllAccounts(allAccounts: ThgAccountViewmodelGen[]) {
    this._allAccounts = allAccounts;
  }

  @Action
  async getAllAccounts() {
    const accounts = await accountService.findAll();
    this.context.commit("mutateAllAccounts", accounts);
  }

  private _account: ThgAccountViewmodelGen | undefined = undefined;

  get account(): ThgAccountViewmodelGen | undefined {
    return this._account;
  }

  @Mutation
  mutateAccount(account: ThgAccountViewmodelGen) {
    this._account = account;
  }

  @Action
  async createAccount(data: { query: ThgAccountControllerCreateAccountParamsGen; dto: ThgAccountDtoGen }) {
    const account = await accountService.create(data.query, data.dto);
    this.context.commit("mutateAccount", account);
  }

  @Action
  async updateAccount(data: { accountId: string; dto: ThgUpdateAccountDtoGen }) {
    const account = await accountService.update(data.accountId, data.dto);
    this.context.commit("mutateAccount", account);
  }

  @Action
  async check(): Promise<ThgOperationIdViewModelGen> {
    return accountService.check();
  }

  @Action
  getUserAccountNumber(): Promise<number> {
    return accountService.getUserAccountNumber();
  }
}

export const AccountModule = getModule(AccountStore);
